import Nullstack from 'nullstack';
export default function IconTopologyStarRing({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-topology-star-ring",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M14 20a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), "   ", Nullstack.element("path", {
    d: "M14 4a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), "   ", Nullstack.element("path", {
    d: "M6 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), "   ", Nullstack.element("path", {
    d: "M22 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), "   ", Nullstack.element("path", {
    d: "M14 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), "   ", Nullstack.element("path", {
    d: "M6 12h4"
  }), "   ", Nullstack.element("path", {
    d: "M14 12h4"
  }), "   ", Nullstack.element("path", {
    d: "M13.5 5.5l5 5"
  }), "   ", Nullstack.element("path", {
    d: "M5.5 13.5l5 5"
  }), "   ", Nullstack.element("path", {
    d: "M13.5 18.5l5 -5"
  }), "   ", Nullstack.element("path", {
    d: "M10.5 5.5l-5 5"
  }), "   ", Nullstack.element("path", {
    d: "M12 6v4"
  }), "   ", Nullstack.element("path", {
    d: "M12 14v4"
  }), " ");
}